export const state = () => ({
	analyticsPopupShown: false
})

export const getters = {
	analyticsPopupShown: (state) => {
		return state.analyticsPopupShown
	},

	shouldShowPopup: (state, getters, rootState, rootGetters) => {
		// Only show to verified admins
		const permissions = rootGetters['user/permissions']
		if (!permissions || !permissions.isVerifiedAdmin) {
			return false
		}

		// Don't show if already shown
		if (state.analyticsPopupShown) {
			return false
		}

		return true
	}
}

export const mutations = {
	setAnalyticsPopupShown (state, value) {
		state.analyticsPopupShown = value
	}
}

export const actions = {
	markAnalyticsPopupAsShown ({ commit }) {
		commit('setAnalyticsPopupShown', true)

		const custom = { analyticsPopupShown: true }

		try {
			this.$axios.$patch('/api/v1/users/me', { custom })
		} catch (error) {
			this.$log.error('Failed to save analytics popup preference', error)
		}
	}
}
